import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import MembershipTransferStructure from "../../components/transfer/membership-transfer/MembershipTransferStructure";

const MembershipTransferSystem = () => {
  const userInfoData = useSelector(selectUser);

  return <MembershipTransferStructure userInfoData={userInfoData} />;
};

export default MembershipTransferSystem;